import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useMigration } from '../../context/MigrationContext';
import MigrationCodeContent from './MigrationCodeContent';

/**
 * Modal que aparece nada más entrar (una vez por sesión) con el código de
 * migración a ActionEV. Si el usuario no tiene código no renderiza nada.
 */
const MigrationCodeModal = () => {
  const { code, isModalOpen, closeModal } = useMigration();

  if (!code) return null;

  return (
    <Dialog open={isModalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: '#002642', fontWeight: 700 }}>
        Tu código para pasar a ActionEV
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2, color: '#75787B' }}>
          COMHUB se traslada a ActionEV. Con este código tu cuenta, tu sede y tu saldo
          quedan vinculados allá. Guárdalo: lo puedes volver a ver en Mi Billetera y en Ajustes.
        </Typography>
        <MigrationCodeContent code={code} />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} variant="outlined">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MigrationCodeModal;
